var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktokSm(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39828 0.0151875C10.3798 0 11.3558 0.009 12.3306 0C12.3897 1.14806 12.8025 2.3175 13.6429 3.12919C14.4816 3.96113 15.6679 4.34194 16.8222 4.47075V7.49081C15.7405 7.45538 14.6537 7.23037 13.6722 6.76463C13.2447 6.57113 12.8464 6.32194 12.4566 6.06713C12.4515 8.25863 12.4656 10.4473 12.4425 12.6298C12.384 13.6783 12.0381 14.7218 11.4283 15.5858C10.4473 17.0241 8.74465 17.9618 6.99584 17.991C5.92315 18.0523 4.85159 17.7598 3.93753 17.2209C2.42272 16.3277 1.35678 14.6925 1.20153 12.9375C1.18197 12.5658 1.17897 12.1934 1.19253 11.8215C1.32753 10.3944 2.03347 9.02925 3.12922 8.10056C4.37122 7.01888 6.11103 6.50362 7.74003 6.8085C7.75522 7.91944 7.71078 9.02925 7.71078 10.1402C6.96659 9.89944 6.09697 9.96694 5.44672 10.4186C4.97098 10.732 4.61146 11.1931 4.42353 11.7309C4.26828 12.1112 4.31272 12.5336 4.32172 12.9375C4.50003 14.1683 5.68353 15.2027 6.94691 15.0907C7.78447 15.0817 8.58715 14.5957 9.02365 13.8842C9.16484 13.635 9.32291 13.3802 9.33134 13.0871C9.40503 11.7456 9.37578 10.4096 9.38478 9.06806C9.39097 6.04463 9.37578 3.02962 9.39884 0.01575L9.39828 0.0151875Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokSm);
export default __webpack_public_path__ + "static/media/tiktok-sm.b8b1f3277282c9bcb2c2e9b9e030008d.svg";
export { ForwardRef as ReactComponent };